import devConstGlobal from './dev.js'
// var mainHost = ''

// if (process.env.platform === 'app') {
//     mainHost = process.env.mainHost
// } else {
//     mainHost = 'http://' + window.location.host
// }

// let NODE_ENV = process.env.NODE_ENV
/**
 * 初始化主域名
 * 在浏览器环境中使用window.location获取当前主机
 */
var mainHost = 'http://' + window.location.host;

/**
 * 判断当前环境是否为生产环境
 * @returns {boolean} 是否为生产环境
 */
const isProduction = () => {
  // 方案1：使用Vue CLI或Vite注入的环境变量（如果可用）
  if (typeof window !== 'undefined' && window.VUE_APP_ENV === 'production') {
    return true;
  }
  
  // 方案2：根据域名判断
  const hostname = window.location.hostname;
  return hostname.includes('production') || 
         hostname.includes('prod') || 
         !hostname.includes('localhost') && !hostname.includes('192.168');
};

// 获取当前环境
let NODE_ENV = isProduction() ? 'production' : 'development';
const prodConstGlobal = {
    MainHost: mainHost,
    HostContact: mainHost + '/orgContacts/',
    HostPrivilege: mainHost + '/privilege/',

    HostDefaultImgUpload: mainHost + '/upload',

    HostSource: mainHost + '/',

    HostFileUpload: mainHost + '/apps/file/',

    HostFeedback: mainHost + '/adminPubRes/',
    HostCompany: mainHost + '/pubResDataPlatform/',
    // HostFeedback: 'http://weixin.ggzy.gov.cn/adminPubRes/',

    pageSize: 16,
    // platform: process.platform,
    platform: 'browser',
    ueditorDefault: 'static/ueditor1_4_3_3/'
}
let constGlobal = (NODE_ENV == 'production') ? prodConstGlobal : devConstGlobal

export default constGlobal